var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{attrs:{"id":"modals"}},_vm._l((_vm.modals),function(modal,i){return _c(modal.component,{key:'modal'+i,tag:"component",attrs:{"params":modal.params}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }